import { OrderProgressEntity, OrderProgressRuleEntity, OrderProgressChuteEntity } from 'orders/domain/entities/order.entity'

export interface SorterChuteView {
    chuteNumber: number
    containers: Array<{
        code: string
        status: string
        statusDescription: string
        packageCount: number
    }>
    packageCount: number
}

export interface SorterRuleView {
    name: string
    sequence?: number | null
    chutes: SorterChuteView[]
    chuteNumbers: number[]
    totalPackages: number
}

/**
 * Adapter para órdenes de tipo Sorter.
 * Transforma los datos de `/orders/:id/progress` en vistas para la UI.
 */
export class SorterOrderAdapter {
    /**
     * Construye las vistas de reglas desde los datos de progress.
     * Cada regla tiene chutes, y cada chute tiene containers.
     */
    static buildRuleViews(progress: OrderProgressEntity): SorterRuleView[] {
        return progress.rules.map((rule) => SorterOrderAdapter.mapRule(rule))
    }

    private static mapRule(rule: OrderProgressRuleEntity): SorterRuleView {
        const chutes = (rule.chutes ?? []).map((ch) => SorterOrderAdapter.mapChute(ch))
        const chuteNumbers = chutes.map((c) => c.chuteNumber)

        return {
            name: rule.ruleName,
            sequence: rule.sequence ?? null,
            chutes,
            chuteNumbers,
            totalPackages: rule.totalPackages,
        }
    }

    private static mapChute(chute: OrderProgressChuteEntity): SorterChuteView {
        return {
            chuteNumber: chute.chuteNumber,
            containers: (chute.containers ?? []).map((c) => ({
                code: c.code,
                status: c.status,
                statusDescription: c.statusDescription,
                packageCount: c.packageCount,
            })),
            packageCount: chute.packageCount,
        }
    }
}
